// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__zeQDy","heroButtons":"SectionHero_heroButtons__mAZyn","heroButton":"SectionHero_heroButton__Vf8sL","heroIcon":"SectionHero_heroIcon__CrPYM"};